import React, { useCallback } from "react";
import {
  Button,
  ButtonGroup,
  Heading,
  Popup,
  PopupSection,
  Text,
} from "@flixbus/honeycomb-react";
import { Icon, IconDelete } from "@flixbus/honeycomb-icons-react";
import type { DeleteCalculationConfirmationPopupProps } from "./DeleteCalculationConfirmationPopup.types";

export const deleteCalculationConfirmationPopupId =
  "delete-calculation-confirmation-popup";

const titleId = "delete-calculation-confirmation-title";
const contentId = "delete-calculation-confirmation-content";

const DeleteCalculationConfirmationPopup: React.FC<
  DeleteCalculationConfirmationPopupProps
> = ({ candidate, active, loading, targetRef, onCancel, onConfirm }) => {
  const handleClose = useCallback(() => {
    if (!loading) onCancel();
  }, [loading, onCancel]);

  return (
    <Popup
      id={deleteCalculationConfirmationPopupId}
      active={active}
      aria-labelledby={titleId}
      aria-describedby={contentId}
      onOverlayClick={handleClose}
      targetRef={targetRef}
      loading={loading}
    >
      <PopupSection type="icon">
        <Icon InlineIcon={IconDelete} size={6} aria-hidden="true" />
      </PopupSection>
      <PopupSection type="title">
        <Heading id={titleId} size={2} sectionHeader flushSpace>
          Delete this calculation?
        </Heading>
      </PopupSection>
      <PopupSection type="content" id={contentId}>
        <Text>This cannot be undone.</Text>
        {candidate && <Text>{candidate.name}</Text>}
      </PopupSection>
      <PopupSection type="actions">
        <ButtonGroup justify="center">
          <Button appearance="secondary" disabled={loading} onClick={onCancel}>
            Cancel
          </Button>
          <Button
            appearance="primary"
            disabled={loading}
            loading={loading}
            onClick={onConfirm}
          >
            Delete
          </Button>
        </ButtonGroup>
      </PopupSection>
    </Popup>
  );
};

export default React.memo(DeleteCalculationConfirmationPopup);
